// Vocabulario por segmento: em clinica o CRM fala a lingua da recepcao.
// Quem nao e clinica continua vendo Leads, Negociacoes e Produtos.
const CLINICA = {
  "Leads": "Contatos",
  "Negociações": "Oportunidades",
  "Produtos": "Procedimentos",
  "Clientes": "Pacientes",
  "Produtos e Serviços": "Procedimentos e pacotes",
  "Catálogo usado nos orçamentos": "Procedimentos que entram nos orçamentos e pacotes",
  "Novo item do catálogo": "Novo procedimento",
  "Editar item": "Editar procedimento",
  "Ex: CAM-4231": "Ex: PROC-012",
  "Ex: Câmera IP Bullet 4MP": "Ex: Limpeza de pele profunda",
  "Ex: Câmeras": "Ex: Facial",
  "Ex: Intelbras": "Ex: marca do produto usado",
  "Detalhes técnicos, especificações...": "O que está incluso, duração, cuidados antes e depois...",
  "Novo lead": "Novo contato",
  "Editar lead": "Editar contato",
  "Novo cliente": "Novo paciente",
  "Editar cliente": "Editar paciente",
  "Acompanhe suas oportunidades de venda": "Acompanhe as oportunidades e os tratamentos",
  "Todos os vendedores": "Todos os profissionais",
  "Vendedor": "Profissional",
  "Vendedores": "Profissionais",

  // cadastro do paciente
  "Cliente desde": "Paciente desde",
  "Salvar cliente": "Salvar paciente",
  "Nome da empresa obrigatório": "Informe o nome do paciente",
  "Informações relevantes sobre o cliente...": "Preferências de horário, profissional preferido, observações do atendimento...",
  "🔍 Buscar cliente, CNPJ...": "🔍 Buscar paciente, CPF ou telefone...",
  "Nome da empresa... (Enter para salvar)": "Nome do paciente... (Enter para salvar)",
  "Carteira de clientes e contratos": "Pacientes da clínica",
  "clientes": "pacientes",
  "cliente": "paciente",

  // tabela de pacientes
  "Empresa": "Paciente",
  "Contato": "Responsável",
  "Segmento": "Como conheceu",
  "+ Novo cliente": "+ Novo paciente",
  "+ Adicionar cliente": "+ Adicionar paciente",
  "Nenhum cliente encontrado": "Nenhum paciente encontrado",
  "Clique em \"+ Novo cliente\" para começar": "Clique em \"+ Novo paciente\" para começar",

  // orcamentos
  "Cliente": "Paciente",
  "Cliente *": "Paciente *",
  "Vendedor *": "Profissional *",
  "Negociação / Serviço": "Oportunidade",
  "Empresa / Cliente *": "Nome do paciente *",
  "Cadastrar cliente": "Cadastrar paciente",
  "CNPJ": "CPF",
  "Ranking por vendedor": "Ranking por profissional",
  "Prazo de entrega": "Início do tratamento",
  "Serviços": "Procedimentos",
  "Ex: LDC Rondonopolis": "Ex: Maria Silva",
  "Nome do contato": "Nome do responsável",
  "00.000.000/0001-00": "000.000.000-00",
  "Digite para buscar o cliente...": "Digite para buscar o paciente...",
  "Buscar vendedor...": "Buscar profissional...",
  "Ex: CFTV Perimetral": "Ex: Protocolo de limpeza de pele",
  "Ex: 50% entrada, 50% na entrega": "Ex: 50% na 1ª sessão, 50% em 30 dias",
  "Ex: 15 dias úteis": "Ex: começa em 7 dias",
  "Nenhum orcamento no periodo.": "Nenhum orçamento no período.",
};

const PALAVRAS = ["clinica", "estetica", "odonto", "harmoniza", "fisioterapia", "salao", "saude", "medica", "beleza"];

let ehClinicaCache;

function ehClinica() {
  if (ehClinicaCache !== undefined) return ehClinicaCache;
  let seg = "";
  try {
    const e = JSON.parse(localStorage.getItem("crm_empresa") || "{}");
    seg = String((e && e.segmento) || "");
  } catch (x) {}
  seg = seg.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  ehClinicaCache = !!seg && PALAVRAS.some((p) => seg.indexOf(p) !== -1);
  return ehClinicaCache;
}

// Chamar ao entrar, sair ou trocar de empresa
export function limparVocab() { ehClinicaCache = undefined; }

export function ehSegmentoClinica() { return ehClinica(); }

// Testa um texto de segmento direto. Serve no cadastro, quando ainda nao existe empresa salva.
export function segmentoEhClinica(texto) {
  const s = String(texto || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return !!s && PALAVRAS.some((p) => s.indexOf(p) !== -1);
}

// Traduz um texto da interface para o vocabulario da empresa logada
export function t(texto) {
  if (!texto) return texto;
  return ehClinica() ? (CLINICA[texto] || texto) : texto;
}
